import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PartnerRouteParams } from '../../core/routeparams';

@Component({
  selector: 'app-entry',
  template: ``,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EntryComponent implements OnInit {
  private partnerId: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.partnerId = (this.route.snapshot.params as PartnerRouteParams).partnerId;

    if (this.partnerId) {
      this.router.navigateByUrl('/partner/' + this.partnerId + '/dashboard');
    }
  }
}
